import Vue from "vue"

import ApiClient from "@/lib/api-client"

export default {
  namespaced: true,

  state: {
    submissions: {}, // taskId => submission
    fetchedSubmissions: {}
  },

  mutations: {
    setSubmission(state, { taskId, submission }) {
      Vue.set(state.submissions, taskId, submission)
    },

    setFetchedSubmission(state, taskId) {
      Vue.set(state.fetchedSubmissions, taskId, true)
    }
  },

  getters: {
    submissionForTask: state => taskId => state.submissions[taskId] || null,
    hasFetchedSubmission: state => taskId => !!state.fetchedSubmissions[taskId]
  },

  actions: {
    async fetchTaskSubmission({ commit, state }, taskId) {
      if (!taskId) return null
      if (state.fetchedSubmissions[taskId]) {
        return state.submissions[taskId] || null
      }

      const res = await ApiClient.get(`/tasks/${taskId}/submission`)
      const submission = res.data?.task_submission || null

      commit("setSubmission", { taskId, submission })
      commit("setFetchedSubmission", taskId)

      return submission
    },

    async createTaskSubmission({ commit }, { taskId, value }) {
      const res = await ApiClient.post(`/tasks/${taskId}/submissions`, {
        value
      })
      const submission = res.data?.task_submission
      commit("setSubmission", { taskId, submission })
      commit("setFetchedSubmission", taskId)
      return submission
    }
  }
}
